import { useChartContext } from 'shared/components/charts/BarChart/hooks';

import { Bar } from './components/Bar';

import type { FC } from 'react';

export const Bars: FC = () => {
  const { data } = useChartContext();

  return (
    <g>
      {data.map(({ id, x }, index) => (
        <Bar
          key={id}
          id={id}
          x={x}
          y={data[index].y}
          yLabel={data[index].yLabel}
        />
      ))}
    </g>
  );
};
